<template>
  <div id="unitLeftTwo" class="echarts"></div>
</template>
<script>
import { defineComponent, reactive, toRefs, onMounted } from "vue";
import * as echarts from "echarts";
import { economicType } from "@/api/dataAnalysis/unitOfAnalysis.js";
export default defineComponent({
  name: "",
  components: {},
  props: {},
  setup(props) {
    const data = reactive({
      obj: [],
      regionId: 0,
    });
    const refData = toRefs(data);
    // 居住现状
    const economicTypelist = async () => {
      const res = await economicType(data.regionId);
      res.data.forEach((v) => {
        data.obj.push({ value: v.value, name: v.name });
      });
    };
    onMounted(async () => {
      await economicTypelist();
      data.regionId = JSON.parse(localStorage.getItem("regionId"));
      const myChart = echarts.init(document.getElementById("unitLeftTwo"));
      myChart.setOption({
        title: {
          // zlevel: 0,
          text: ["单位规模"].join("\n"),
          top: "center",
          left: "150",
          textAlign: "center",
          textStyle: {
            // 文字配置
            color: "rgb(255,255,255)", // 文字颜色
            align: "center", // 对齐方式
          },
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          right: 30,
          top: 60,
          bottom: 10,
          type: "scroll",
          textStyle: {
            color: "#ccc",
          },
        },
        series: [
          {
            name: "单位规模",
            type: "pie",
            radius: ["40%", "70%"],
            right: 90,
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center",
            },
            // emphasis: {
            //   label: {
            //     show: true,
            //     fontSize: "20",
            //     fontWeight: "bold",
            //   },
            // },
            labelLine: {
              show: false,
            },
            data: data.obj,
          },
        ],
      });
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    });
    return {
      ...refData,
      economicTypelist,
    };
  },
});
</script>
<style lang="scss" scoped>
#unitLeftTwo {
  width: 100%;
  height: 90%;
}
</style>
